export default {
  expenscat: null,
  expensedesc: null,
  amount: null,
  branch: null,
  addedby: null,
  voucher: null,
};
